import type { FillLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const AT_MUNICIPALITIES_SOURCE_ID = 'municipalities';
export const AT_MUNICIPALITIES_LAYER_NAME = 'municipalities';

export const AT_MUNICIPALITIES_LAYER_CONFIG: FillLayerSpecification = {
  id: AT_MUNICIPALITIES_LAYER_NAME,
  type: 'fill',
  source: AT_MUNICIPALITIES_SOURCE_ID,
  'source-layer': 'gemeinden',
  paint: {
    'fill-outline-color': 'rgba(0,0,0,0.3)',
    'fill-color': 'rgba(0,0,0,0.1)',
  },
};

export const AT_MUNICIPALITIES_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.at-gemeinden-dev',
};

export interface AT_MUNICIPALITIES_SOURCE_FEATURE_PROPERTIES {
  color: string;
  displayName: string;
  key: string;
}
